
export const routes = [
  {
    path: 'cart_confirm',
    name: 'CartConfirm',
    component: () => import('src/pages/full_dine_in/cart_confirm/index.vue'),
    meta: {
      requireAuth: true,
      header: {
        showHeader: true,
        title: 'title.cart_confirm',
        showBg: true,
        showBack: true,
        backLink: 'cart'
      }
    }
  },
  {
    path: 'ongoing',
    name: 'OnGoing',
    component: () => import('src/pages/full_dine_in/on_going/index.vue'),
  },
  {
    path: 'full_checkout',
    name: 'FullCheckout',
    component: () => import('src/pages/full_dine_in/checkout/index.vue'),
    meta: {
      requireAuth: true,
      header: {
        showHeader: true,
        title: 'title.full_checkout',
        showBg: true,
        showBack: true,
        shadow: true,
        backLink: 'ongoing'
      }
    }
  },
  {
    path: 'full_result',
    name: 'FullResult',
    component: () => import('src/pages/full_dine_in/result/index.vue'),
    children: [
      {
        path: 'pay_success',
        name: 'FullPaySuccess',
        component: () => import('src/pages/full_dine_in/result/PaySuccess.vue')
      },
      {
        path: 'cash_waiting',
        name: 'FullCashWaiting',
        component: () => import('src/pages/full_dine_in/result/CashWaiting.vue')
      },
      {
        path: 'canceled',
        name: 'FullCanceled',
        component: () => import('src/pages/full_dine_in/result/Cancel.vue'),
      }
    ]
  }
]
